import React from 'react';
import { Icon } from '@cloudscape-design/components';
import './button.scss';

export interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'small' | 'medium' | 'large';
  icon?: string;
  iconPosition?: 'leading' | 'trailing';
  loading?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'medium',
  icon,
  iconPosition = 'leading',
  loading = false,
  disabled = false,
  onClick,
  className = '',
  type = 'button',
}) => {
  const buttonClasses = [
    'finspace-button',
    `finspace-button--${variant}`,
    `finspace-button--${size}`,
    loading && 'finspace-button--loading',
    disabled && 'finspace-button--disabled',
    className
  ].filter(Boolean).join(' ');

  const handleClick = () => {
    if (!disabled && !loading && onClick) {
      onClick();
    }
  };

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={handleClick}
      disabled={disabled || loading}
      aria-disabled={disabled || loading}
    >
      {loading ? (
        <div className="finspace-button__spinner" />
      ) : (
        <>
          {icon && iconPosition === 'leading' && (
            <Icon name={icon as any} size="small" />
          )}
          <span className="finspace-button__text">{children}</span>
          {icon && iconPosition === 'trailing' && (
            <Icon name={icon as any} size="small" />
          )}
        </>
      )}
    </button>
  );
};

export default Button;
